import { useRef } from "react";
import { toCanvas } from "html-to-image";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getEmployee, selectProcesses } from "./processSlices";
import AuthSkeleton from "../auth/AuthSkeleton";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import {
  Tooltip,
  useTheme,
  Stack,
  Box,
  Container,
  Typography,
} from "@mui/material";
import Image from "mui-image";
import { Backspace, Download } from "@mui/icons-material";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import jsPDF from "jspdf";
import { selectAuth } from "../auth/authSlice";
import { getCompany, selectSetups } from "../setups/setupSlices";
import { KuwaitContractWebPage } from "../../components/reports/KuwaitContractWebPage";
import { AuthUser } from "../auth/types/authType";
import { NavLink as RouterLink } from "react-router-dom";

function ContractTemplate() {
  const { id } = useParams() as {
    id: string;
  };
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { user } = useAppSelector(selectAuth);
  const { selectedCompany } = useAppSelector(selectSetups);

  const {
    selectedEmployee: currentEmployee,
    employeesWithCount: { employees },
    loading,
  } = useAppSelector(selectProcesses);

  useEffect(() => {
    if (id && id.length > 10) {
      dispatch(getEmployee(id));
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (user && user.company) {
      dispatch(getCompany(user.company._id as string));
    }
  }, [dispatch, user]);

  const ref = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const ref3 = useRef<HTMLDivElement>(null);
  const ref4 = useRef<HTMLDivElement>(null);
  const handleGeneratePdf = () => {
    if (
      ref.current === null ||
      ref2.current === null ||
      ref3.current === null ||
      ref4.current === null
    ) {
      return;
    }
    const fileName = currentEmployee.givenName as string;

    const doc = new jsPDF("p", "mm", "a4", false);
    toCanvas(ref.current)
      .then((canvas) => {
        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const imgData = canvas.toDataURL("image/png");
        doc.addImage({
          imageData: imgData,
          format: "PNG",
          x: 4,
          y: 4,
          width: imgWidth,
          height: imgHeight,
          alias: "alias1",
          compression: "FAST",
        });
        doc.addPage();
        toCanvas(ref2.current as HTMLDivElement)
          .then((canvas2) => {
            const imgWidth2 = 200;
            const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
            const imgData2 = canvas2.toDataURL("image/png");
            //console.log(imgData);
            doc.addImage({
              imageData: imgData2,
              format: "PNG",
              x: 4,
              y: 4,
              width: imgWidth2,
              height: imgHeight2,
              alias: "alias2",
              compression: "FAST",
            });

            doc.addPage();
            toCanvas(ref3.current as HTMLDivElement)
              .then((canvas3) => {
                const imgWidth3 = 200;
                const imgHeight3 = (canvas3.height * imgWidth3) / canvas3.width;
                const imgData3 = canvas3.toDataURL("image/png");
                doc.addImage({
                  imageData: imgData3,
                  format: "PNG",
                  x: 4,
                  y: 4,
                  width: imgWidth3,
                  height: imgHeight3,
                  alias: "alias3",
                  compression: "FAST",
                });
                doc.addPage();
                toCanvas(ref4.current as HTMLDivElement)
                  .then((canvas4) => {
                    const imgWidth4 = 200;
                    const imgHeight4 =
                      (canvas4.height * imgWidth4) / canvas4.width;
                    const imgData4 = canvas4.toDataURL("image/png");
                    doc.addImage({
                      imageData: imgData4,
                      format: "PNG",
                      x: 4,
                      y: 4,
                      width: imgWidth4,
                      height: imgHeight4,
                      alias: "alias4",
                      compression: "FAST",
                    });
                    doc.save(`${fileName}.pdf`);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Grid container>
        <Grid item sx={{ p: 1 }} xs={12}>
          {currentEmployee &&
          currentEmployee._id &&
          currentEmployee._id.length > 0 ? (
            <Container maxWidth="md">
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between">
                  <Tooltip title="Back to Employee Detail">
                    <Button
                      color="secondary"
                      variant="contained"
                      component={RouterLink}
                      to={"/app/employee/" + currentEmployee._id}
                      size="small"
                    >
                      <Backspace />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Download Contract">
                    <Button
                      color="primary"
                      onClick={handleGeneratePdf}
                      variant="contained"
                      size="small"
                    >
                      <Download /> Download Contract
                    </Button>
                  </Tooltip>
                </Stack>

                <Box
                  component={Paper}
                  elevation={3}
                  sx={{ display: "block", overflow: "hidden", width: "100%" }}
                >
                  <div dir={theme.direction === "rtl" ? "rtl" : "ltr"}>
                    <KuwaitContractWebPage
                      ForwardedRef={{ ref, ref2, ref3, ref4 }}
                      employee={currentEmployee}
                      user={user as AuthUser}
                    />
                    {/* <Grid
                      container
                      spacing={1}
                      sx={{
                        p: 1,
                      }}
                    >
                    </Grid> */}
                    {/* ADD_PAGE */}
                    {/* <Box ref={ref2}>
                      <KuwaitContractWebPage
                        ref={ref2}
                        employee={currentEmployee}
                        user={user as AuthUser}
                      />
                    </Box> */}
                  </div>
                </Box>
              </Stack>
            </Container>
          ) : loading === "pending" ? (
            <AuthSkeleton />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <Image
                src="/No_Data.svg"
                alt="No Data"
                width={250}
                height={120}
                shift="top"
                distance="2rem"
                shiftDuration={320}
                style={{
                  borderRadius: "50%",
                }}
              />
              <Typography variant="h5">No Data Found</Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default ContractTemplate;
